// src/components/private/common_components/renderIconOption.js
// Helper function to render icons with tooltips

import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

// Helper function to render icons with tooltips
const renderIconOption = (iconName, tooltipText, selectedOption, optionValue, setSelectedOption) => {

    const optionStyle = {
        cursor: 'pointer',
        padding: '10px 10px 10px 8px', // Reduce padding on the left to move icons leftward
        margin: '5px 0',
        borderRadius: '5px',
        display: 'flex', // Use flexbox to better control the alignment
        alignItems: 'center', // Align items vertically in the center
        justifyContent: 'flex-start' // Align items to the left
    };

    // Style for highlighting an option on hover
    const hoverStyle = {
        backgroundColor: '#f0f0f0', // Light grey background on hover
        // Use your CSS module className instead if you're using CSS modules
        // Example: className={styles.hoverStyle}
    };

    return (
        <OverlayTrigger
            placement="right"
            overlay={<Tooltip id={`tooltip-${optionValue}`}>{tooltipText}</Tooltip>}
        >
            <div
                style={{ ...optionStyle, ...(selectedOption === optionValue ? hoverStyle : {}) }}
                onClick={() => setSelectedOption(optionValue)}
                onMouseOver={(e) => e.target.style.backgroundColor = '#f0f0f0'}
                onMouseOut={(e) => e.target.style.backgroundColor = 'transparent'}
            >
                <i className={`bi-${iconName}`} style={{ fontSize: '24px' }}></i>
            </div>
        </OverlayTrigger>
    );
};

export default renderIconOption;